/**
 * OIDC Auth API for Backstage
 *
 * Implements authentication API for OIDC provider (JumpCloud)
 */

import {
  OAuthApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  BackstageIdentityApi,
  SessionApi,
  createApiRef,
  createApiFactory,
  discoveryApiRef,
  oauthRequestApiRef,
  configApiRef,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';

/**
 * OIDC Auth API Reference
 *
 * This API implements the authentication flow for OIDC providers.
 * It follows the same pattern as other OAuth providers.
 */
export const oidcAuthApiRef = createApiRef<
  OAuthApi &
    OpenIdConnectApi &
    ProfileInfoApi &
    BackstageIdentityApi &
    SessionApi
>({
  id: 'auth.oidc',
});

/**
 * Factory that creates the OIDC auth API implementation
 */
export const oidcAuthApiFactory = createApiFactory({
  api: oidcAuthApiRef,
  deps: {
    discoveryApi: discoveryApiRef,
    oauthRequestApi: oauthRequestApiRef,
    configApi: configApiRef,
  },
  factory: ({ discoveryApi, oauthRequestApi, configApi }) => {
    const environment =
      configApi.getOptionalString('auth.environment') || 'production';

    return OAuth2.create({
      configApi,
      discoveryApi,
      oauthRequestApi,
      provider: {
        id: 'oidc',
        title: 'JumpCloud',
        icon: () => null,
      },
      environment,
      defaultScopes: ['openid', 'profile', 'email', 'offline_access'],
    });
  },
});
